module.exports = "<div class=\"body-content\">\n  <app-navbar></app-navbar>\n  <app-navlinks></app-navlinks>\n\n  <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n\n  <app-footer></app-footer>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/shared/base-public/base-public.component.html
// module id = ../../../../../src/app/pages/shared/base-public/base-public.component.html
// module chunks = main